import { render, staticRenderFns } from "./otherDetails.vue?vue&type=template&id=0042884e&scoped=true&"
import script from "./otherDetails.vue?vue&type=script&lang=js&"
export * from "./otherDetails.vue?vue&type=script&lang=js&"
import style0 from "./otherDetails.vue?vue&type=style&index=0&id=0042884e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042884e",
  null
  
)

export default component.exports